// @ts-strict-ignore
import {NO_MAX_DATE_VALUE} from 'common/components/calendar/types';
import {DateRangeType} from 'common/types/reports/bookmark';

import {DateRange} from './date-range';
import {TimeUnit} from './types';

export class PropertyFilterDateRange extends DateRange {
  public getCalendarMaxDate(): string {
    return NO_MAX_DATE_VALUE;
  }

  public getDateRangeTypeOptions(): DateRangeType[] {
    return [
      DateRangeType.RelativeAfter,
      DateRangeType.RelativeBefore,
      DateRangeType.Between,
      DateRangeType.NotBetween,
      DateRangeType.On,
      DateRangeType.NotOn,
      DateRangeType.Since,
      DateRangeType.Before,
      DateRangeType.NotRelativeAfter,
      DateRangeType.RelativeFuture,
    ];
  }

  public getTimeUnitOptions(): TimeUnit[] {
    return [TimeUnit.Minute, TimeUnit.Hour, TimeUnit.Day, TimeUnit.Week, TimeUnit.Month];
  }
}
